export default "__VITE_ASSET__24b0fee2__"